/**
 * Цели шагов тура (E4.6b): стабильный атрибут data-training-target на элементе страницы,
 * а не селектор по классу оформления. Один элемент может служить нескольким шагам --
 * идентификаторы перечисляются через пробел.
 */

import type { StepId } from './catalog';

export type TrainingTargetId = StepId;

export const TRAINING_TARGET_ATTRIBUTE = 'data-training-target';

/** Атрибуты цели для разметки страницы */
export function trainingTarget(
	...ids: TrainingTargetId[]
): Record<typeof TRAINING_TARGET_ATTRIBUTE, string> {
	return { [TRAINING_TARGET_ATTRIBUTE]: ids.join(' ') };
}

/**
 * Элемент не скрыт: ни он, ни предки не скрыты атрибутом hidden или display: none.
 * aria-hidden не учитывается: открытый оверлей тура сам скрывает страницу от чтения с экрана
 */
function shown(element: HTMLElement): boolean {
	if (element.closest('[hidden]')) return false;
	for (let node: HTMLElement | null = element; node; node = node.parentElement) {
		if (window.getComputedStyle(node).display === 'none') return false;
	}
	return true;
}

/** Показанный элемент цели шага или null */
export function findTrainingTarget(
	id: TrainingTargetId,
	root: ParentNode = document,
): HTMLElement | null {
	const candidates = Array.from(root.querySelectorAll<HTMLElement>('[data-training-target]'));
	return (
		candidates.find(
			(element) =>
				(element.dataset.trainingTarget ?? '').split(' ').includes(id) &&
				shown(element) &&
				!element.matches('[aria-busy="true"]') &&
				!element.querySelector(
					'[data-workspace-state="loading"], [data-workspace-state="error"], [data-workspace-state="forbidden"], [data-workspace-state="unavailable"]',
				),
		) ?? null
	);
}
